/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_ShortformInputs */

const en_delete_shortform = /** @type {(inputs: Delete_ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete shortform`)
};

const fr_delete_shortform = /** @type {(inputs: Delete_ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer l'abréviation`)
};

const de_delete_shortform = /** @type {(inputs: Delete_ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurzform löschen`)
};

const it_delete_shortform = /** @type {(inputs: Delete_ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina abbreviazione`)
};

const ru_delete_shortform = /** @type {(inputs: Delete_ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить краткую форму`)
};

const es_delete_shortform = /** @type {(inputs: Delete_ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar formato corto`)
};

const zh_cn2_delete_shortform = /** @type {(inputs: Delete_ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除缩写`)
};

const ja_delete_shortform = /** @type {(inputs: Delete_ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショートフォームを削除`)
};

const hi_delete_shortform = /** @type {(inputs: Delete_ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संक्षिप्त रूप हटाएं`)
};

const pt_pt2_delete_shortform = /** @type {(inputs: Delete_ShortformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir forma abreviada`)
};

/**
* | output |
* | --- |
* | "Delete shortform" |
*
* @param {Delete_ShortformInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const delete_shortform = /** @type {((inputs?: Delete_ShortformInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_ShortformInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_delete_shortform(inputs)
	if (locale === "de") return de_delete_shortform(inputs)
	if (locale === "it") return it_delete_shortform(inputs)
	if (locale === "ru") return ru_delete_shortform(inputs)
	if (locale === "es") return es_delete_shortform(inputs)
	if (locale === "zh-CN") return zh_cn2_delete_shortform(inputs)
	if (locale === "ja") return ja_delete_shortform(inputs)
	if (locale === "hi") return hi_delete_shortform(inputs)
	if (locale === "pt-PT") return pt_pt2_delete_shortform(inputs)
	return en_delete_shortform(inputs)
});